/* Pagination helper */
export default {
  data: function () {
    return {
      page: 1,
      numberOfPages: 1,
      itemsPerPage: 5,
      itemsPerPageArray: [5, 10, 15, 20],
      isLastPage: true,
      totalNumberOfItems: 0
    }
  },

  computed: {
    isFirstPage() {
      return this.page === 1
    },

    legend() {
      const recordNumberMin = (this.page-1) * this.itemsPerPage + 1
      const recordNumberMax = Math.min((this.page * this.itemsPerPage), this.totalNumberOfItems)
      return recordNumberMin
        + '-'
        + recordNumberMax
        + ' / '
        + this.totalNumberOfItems
    },
  },

  methods: {

  },

};
